import ActionTypes from '../actions/types';
import { defaultState } from './defaultState';
import { setState, resetState, setObjectToState } from './helper';

export const initialState = defaultState.userAccommodationInfo;

export default (state = initialState, action) => {

  switch (action.type) {

    case ActionTypes.SET_USER_ACCOMMODATION_INFO:
      return setObjectToState(state, {
        qualifiedSpots: action.qualifiedSpots,
        heldSpot: action.heldSpot,
        reservedSpots: action.reservedSpots,
        attendee: action.attendee
      });

    case ActionTypes.SET_RESERVED_SPOTS:
      return setState(state, action, 'reservedSpots');

    case ActionTypes.RESET_HELD_SPOTS:
      return resetState(state, 'heldSpot');

    case ActionTypes.UPDATE_HELD_SPOTS:
      return setState(state, action, 'heldSpot');

    case ActionTypes.SET_DEFAULT_ACCOMMODATION_INFO:
      return initialState;

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/userAccommodationReducer.js